













































































import {
  Component, Vue,
} from 'vue-property-decorator';
import RetirementFundSummaryViewModel
  from '@/vue-app/view-models/components/goals-dashboard/create-goal/retirement-fund/retirement-fund-summary-view-model';

@Component({
  name: 'RetirementFundSummary',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class RetirementFundSummary extends Vue {
  view_model = Vue.observable(
    new RetirementFundSummaryViewModel(this),
  );

  created() {
    this.view_model.initialize();
  }
}
